const GAP = 20;
const AVG_CHAR_WIDTH = 8;
/**
 * Estimate if the menu is too long based on the number of items and their captions.
 * THIS IS A ROUGH ESTIMATION - more heuristic than accurate.
 *
 * To avoid investing too much time in unlikly case, it was agreed to go with rough solution.
 */
export const isMenuTooLong = (menuItems, threshold = 800) => {
  const itemCaptions = menuItems.map(({
    caption
  }) => caption);
  const estimatedWidth = itemCaptions.length * GAP + itemCaptions.join('').length * AVG_CHAR_WIDTH;
  return estimatedWidth > threshold;
};